import {
	UPDATE_ITEM_INFO,
	UPDATE_DISPLAY_INFO,
	UPDATE_CATEGORIES,
	SET_ITEM_CATEGORY_DATA,
	SELECT_CATEGORY_DATA,
	SET_ITEM_ERRORS,
	UPDATE_ITEM_IMAGE,
	DELETE_ITEM_IMAGE,
	UPDATE_NEW_CATEGORY_IMAGE,
	DELETE_NEW_CATEGORY_IMAGE,
	RESET_ITEM_ERRORS,
	PAINT_ITEM_DATA,
	RESET_ITEM_INFO,
	SET_ITEM_WARNINGS,
	RESTORE_ITEM_IMAGE,
	IMAGE_UPLOAD_STATUS
} from '../actions/types';
import config from '../../config/config';
import { getItemImagesFromVendor } from '../utills';
const staticImageDomains = config.staticImageDomains[0];

const initialState = {
	itemInfo: {
		productId: '',
		productName: '',
		visibility: 'ON_DISPLAY',
		isSellOnline: true,
		isEnquiryEnabled: false,
		isBulkPricingActive: false,
		activeTab: '',
		unitOfMeasurement: null,
		productReviewState: "onlineProduct",
		isBatchEnabled: false,
		inventoryPolicy: 'track-inventory',
		isPrescriptionRequired: false,
		imageUrlArr: [],
		outletWiseDeliveryList: [],
		variantJson: [],
		variantsInventoryJson: [],
		packagingType: '',
		isAddInventoryLater: false,
		selectedProductGroupIds: 0,
		productGroup: 0,
		bestBeforeUnit: 'months',
		templateId: 0,
		productAttachmentList: null,
		isAutoReorderLevel:true,
		reorderLevel:0,
		isAutoReorderQuantity:true,
		reorderQuantity:0,
		brandName: '',
		manufacturerName: '',
		associatedSuppliers: [],
		associatedSuppliersDetails: []
	},
	undoInfo: [],
	isTemplate: false,
	itemCategoies: [],
	newCategoryImage: [],
	errors: {},
	warnings: {},
	displayInfo: {},
	selectedCategory:[],
	productPuvMap: null,
	imagesUploadStatus: false
};


let genRefMap = (state, data, pageKey, childKey, parentKey = '', options = {},appliedOnIds) => {
	let { printKey, level, linesArr = [] } = options;
	if (!state.categoryRef) {
		state.categoryRef = {}
	}
	if (!state[printKey]) {
		state[printKey] = [];
	}
	let categoryRef = state.categoryRef;
	let lastIndex = data.length - 1;
	for (let [key, value] of Object.entries(data)) {
		value.level = level;
		if (key == 0) {
			value.firstChild = true;
		}
		value.linesToDraw = level;
		let linesArrT = level == 0 ? [] : linesArr.concat(1);
		if (key == lastIndex) {
			value.lastChild = true;
			linesArrT[linesArrT.length - 1] = 0;
		}
		value.linesArr = linesArrT;
		value.objKey = `${parentKey}${key}`;
		state[printKey].push(value);
		let printIndex = state[printKey].length - 1;
		categoryRef[value.productGroupId] = [`${printIndex}`];
		if(appliedOnIds.includes(value.productGroupId)){
			value.is = true;
		}else{
			value.is = false;
		}
		if (childKey && value[childKey]) {
			/** Recusively call this function on all childs */
			genRefMap(state, value[childKey], pageKey, childKey, `${parentKey}${key}.${childKey}.`, {
				printKey,
				level: level + 1,
				parentObj: value,
				linesArr: linesArrT
			},appliedOnIds);
		}
	}
};


const traverseObj = (options = {}) => {
	let {obj, key, isSelected, newState} = options;
	if(!key) {
		return obj;
	}
	key = key.split(".");
	let i = 0;
	key.forEach((item) => {
		obj = obj[item];
		if(i != key.length && obj['childProductGroupsCommand']){
			if(isSelected){
				obj.is = isSelected;
				if(!newState.selectedCategory.includes(obj.productGroupId)){
					newState.selectedCategory.push(obj.productGroupId);
				}
			}else{
				let childCheck = obj['childProductGroupsCommand'];
				if (childCheck && Object.keys(childCheck).length) {
					let selChildCount = 0;
					for (let [key1, value] of Object.entries(childCheck)) {
						if (value.is) {
							selChildCount++;
						}
					}
					if (selChildCount < 2) {
						obj.is = false;
						const index = newState.selectedCategory.indexOf(obj.productGroupId);
						if (index > -1) {
							newState.selectedCategory.splice(index, 1);
						}
					}
				}
			}
		}
	});
	return obj;
};


const selectBrandCatItem = (value, isSelected,newState) => {
		let newValue = value;
		let stateObj = traverseObj({
			obj: newState.editCategoryData,
			key: value.objKey,
			isSelected: isSelected,
			newState:newState
		});
		stateObj.is = isSelected;
		if(isSelected){
			if(!newState.selectedCategory.includes(newValue.productGroupId)){
				newState.selectedCategory.push(newValue.productGroupId);
			}
		}else{
			const index = newState.selectedCategory.indexOf(newValue.productGroupId);
			if (index > -1) {
			newState.selectedCategory.splice(index, 1);
			}
		}
		if(stateObj['childProductGroupsCommand']){
			selectChild({
				object: stateObj['childProductGroupsCommand'],
				isSelected,
				newState
			});
		}
};


const selectChild = (options) => {
	let {
		object, isSelected,newState
	} = options;
	for (let [key, value] of Object.entries(object)) {
		let newValue = value;
		newValue.is = isSelected;
		if(isSelected){
			if(!newState.selectedCategory.includes(newValue.productGroupId)){
				newState.selectedCategory.push(newValue.productGroupId);
			}
		}else{
			const index = newState.selectedCategory.indexOf(newValue.productGroupId);
			if (index > -1) {
			newState.selectedCategory.splice(index, 1);
			}
		}
		if (newValue['childProductGroupsCommand']) {
			selectChild({
				object: newValue['childProductGroupsCommand'],
				isSelected,
				newState
			});
		}
	}
};

export default (state = initialState, action) => {
	const payload = action.payload;
	switch (action.type) {
		case UPDATE_ITEM_INFO: {
			let oldState = state;
			oldState.itemInfo = { ...oldState.itemInfo, ...payload };
			if(action.isDeleteNewCatImage){
				oldState.newCategoryImage = [];
			}
			return {
				...state,
				...oldState
			};
		}
		case UPDATE_DISPLAY_INFO: {
			let oldState = state;
			oldState.displayInfo = { ...oldState.displayInfo, ...payload };
			return {
				...state,
				...oldState
			};
		}
		case UPDATE_CATEGORIES: {
			let oldState = state;
			oldState.itemCategoies = payload || [];
			return {
				...state,
				...oldState
			};
		}
		case SET_ITEM_CATEGORY_DATA: {
			let newState = {
				...state
			};
			let apiData = payload.data;
			if (apiData.status == 'success') {
				newState.editCategoryData = apiData.data;
				newState.printAllCat = undefined;
				genRefMap(newState, newState.editCategoryData, "editCategoryData", "childProductGroupsCommand", '', {
					printKey: "printAllCat",
					level: 0
				},payload.appliedOnIds);
			}
			window.categoryRef = newState;
			let categoryIds = [...payload.appliedOnIds];
			newState.selectedCategory = categoryIds;
			return newState;
		}
		case SELECT_CATEGORY_DATA: {
			// let parentRef = {};
            let newState = {
                ...state
            };
            // newState.showUpdateButton[payload.activeTab] = true;
			// parentRef = newState.categoryRef
			newState.reRenderListFlag = !newState.reRenderListFlag;
			selectBrandCatItem(payload,payload.isSelected,newState);
			let categoryIds = [...newState.selectedCategory];
			newState.selectedCategory = categoryIds;
			// selectBrandCatItem(parentRef, payload.isSelected,payload.childKey,newState, payload);
            return newState;
		}
		case SET_ITEM_ERRORS: {
			let oldState = state;
			oldState.errors = { ...oldState.errors, ...payload };;
			return {
				...state,
				...oldState
			};
		}
		case SET_ITEM_WARNINGS: {
			let oldState = state;
			oldState.warnings = { ...oldState.warnings, ...payload };;
			return {
				...state,
				...oldState
			};
		}
		case RESET_ITEM_ERRORS: {
			let oldState = state;
			oldState.errors = {};
			return {
				...state,
				...oldState
			};
		}
		case UPDATE_ITEM_IMAGE: {
			const newState = {
				...state
			};
			let imageData = payload;
			const newImageUrlArr = newState.itemInfo.imageUrlArr || [];
			if(imageData.fromApp && imageData.imageUrl.uploaded){
				newImageUrlArr.push(imageData.imageUrl);
			}
			if (imageData.imageUrl.uploaded) {
				for (var i = 0; i < newImageUrlArr.length; i++)
					if (newImageUrlArr[i].imgIndex == imageData.imageUrl.imgIndex) {
						newImageUrlArr[i].actualPath = imageData.imageUrl.actualPath;
						newImageUrlArr[i].imageUrl = imageData.imageUrl.imgURL;
						newImageUrlArr[i].uploaded = imageData.imageUrl.uploaded;
						newImageUrlArr[i].finalImageSrc = (imageData.imageUrl.actualPath || staticImageDomains+imageData.imageUrl.imgURL);
						console.log(imageData.imageUrl.galleryId, imageData.imageUrl.id)
						if(imageData.imageUrl.galleryId){
							newImageUrlArr[i].galleryId = imageData.imageUrl.galleryId;
						}
					}
			} else {
				if (imageData.imageUrl.base64Url) {
					newImageUrlArr.push(imageData.imageUrl);
				} else {
					if (imageData.createdfrom == 'url') {
						imageData.finalImageSrc = staticImageDomains + '/product' + imageData.imageUrl;
					} else {
						imageData.finalImageSrc = staticImageDomains + '/product' + imageData.imageUrl;
					}
					newImageUrlArr.push(imageData);
				}
			}
			newState.itemInfo.imageUrlArr = newImageUrlArr;
			newState.imagesUploadStatus = false;
			return newState;
		}
		case DELETE_ITEM_IMAGE: {
			const newState = {
				...state
			};
			newState.undoInfo = [...newState.itemInfo.imageUrlArr];
			newState.itemInfo.imageUrlArr = payload.imageUrlArr;
			return newState;
		}
		case RESTORE_ITEM_IMAGE: {
			const newState = {
				...state
			};
			newState.itemInfo.imageUrlArr = [...newState.undoInfo];
			newState.undoInfo = [];
			return newState;
		}
		case UPDATE_NEW_CATEGORY_IMAGE: {
			const newState = {
				...state
			};
			let imageData = payload;
			let newImageUrlArr = newState.newCategoryImage || [];
			if (imageData.imageUrl.uploaded) {
				newImageUrlArr[0].actualPath = imageData.imageUrl.actualPath;
				newImageUrlArr[0].imageUrl = imageData.imageUrl.imgURL;
				newImageUrlArr[0].uploaded = imageData.imageUrl.uploaded;
				newImageUrlArr[0].finalImageSrc = staticImageDomains + imageData.imageUrl.imgURL;
			} else {
				if (imageData.imageUrl.base64Url) {
					newImageUrlArr.push(imageData.imageUrl);
				} else {
					if (imageData.createdfrom == 'url' || imageData.createdfrom == 'libraryImages') {
						imageData.finalImageSrc = staticImageDomains + '/groups' + imageData.imageUrl;
					} else if (imageData.createdfrom == 'mobileApp') {
						imageData.finalImageSrc = staticImageDomains + '/groups' + imageData.imageUrl;
					} else {
						imageData.finalImageSrc = staticImageDomains + imageData.imageUrl;
					}
					newImageUrlArr.push(imageData);
				}
			}
			newState.newCategoryImage = newImageUrlArr;
			return newState;
		}
		case DELETE_NEW_CATEGORY_IMAGE: {
			const newState = {
				...state
			};
			newState.newCategoryImage = []
			return newState;
		}
		case PAINT_ITEM_DATA: {
			let data = {}, displayData = {}, consignmentData = {};
			let isTemplate = payload.productCommand.templatingType == 'TEMPLATING';
			const consignmentCommand = payload.productCommand.consignmentCommand ? payload.productCommand.consignmentCommand : {};
			data.productName = payload.productCommand.productName;
			data.imageUrlArr = [];
			data.imageUrlArr = getItemImagesFromVendor(payload.productCommand);
			data.isSellOnline = payload.productCommand.isSellOnline;
			data.isEnquiryEnabled = !!payload.productCommand.isEnquiryEnabled;
			data.isBulkPricingActive = !!payload.productCommand.isBulkPricingActive;
			data.activetab = payload.productCommand.activetab;
			data.unitOfMeasurement = payload.productCommand.unitOfMeasurement;
			data.productReviewState = 'onlineProduct';
			data.isBatchEnabled = !!payload.productCommand.isBatchEnabled;
			data.isAddInventoryLater = !!payload.productCommand.isAddInventoryLater;
			data.isPrescriptionRequired = !!payload.productCommand.isPrescriptionRequired;
			data.outletWiseDeliveryList = payload.productCommand.outletWiseDeliveryList;
			data.packagingType = payload.productCommand.packagingType;
			data.selectedProductGroupIds = payload.productCommand.selectedProductGroupIds ? payload.productCommand.selectedProductGroupIds.toString() : '';
			data.productGroupBreadCrumbList = payload.productCommand.productGroupBreadCrumbList ? payload.productCommand.productGroupBreadCrumbList : '';
			data.barcode = consignmentCommand.barcode;
			data.priceAndVisitRange = payload.productCommand.priceAndVisitRange;
			data.newmrp = payload.productCommand.newmrp || consignmentCommand.mrp;
			data.newsellingPrice = payload.productCommand.newsellingPrice || consignmentCommand.sellingPrice;
			data.spPerPc = payload.productCommand.spPerPc || consignmentCommand.spPerPc;
			data.category = (payload.productCommand.category ? payload.productCommand.category : null) || (payload.productCommand.keywordId ? payload.productCommand.keywordId : null);
			data.leafId = payload.productCommand?.psv_node_id;
			data.psv_node_id = payload.productCommand?.psv_node_id;
			data.psv_node_name = payload.productCommand?.psv_node_name;
			data.templateId = payload.productCommand.productId;
			data.manufacturerName = payload.productCommand.manufacturerName;
			data.brandName = payload.productCommand.brandName;
			data.itemType = payload.productCommand.productGroup || true;
			data.bestBeforeUnit = consignmentCommand.bestBefore ? payload.productCommand.consignmentCommand.bestBefore.split("-")[1] : 'months';
			data.productAttachmentList = payload.productCommand.productAttachmentList ? JSON.parse(payload.productCommand.productAttachmentList) : null;
			if (payload.isEdit) {
				data.isEdit = payload.isEdit;
			}
			if(!payload.isEdit && data.templateId){
				data.newmrp = data.newmrp == "0.00" ? "" : data.newmrp;
				data.newsellingPrice = data.newmrp;
			}
			if (consignmentCommand.manufacturingDate) {
				let tempDateObj = payload.productCommand.consignmentCommand.manufacturingDate.split('T')[0];
				let manufDate = tempDateObj.split('-').reverse();
				data.manufacturingDate = manufDate.join('/');
				data.expiryDate = data.manufacturingDate;//for bug #257123
			} else if (consignmentCommand.expiryDate) {
				let tempDateObj = payload.productCommand.consignmentCommand.expiryDate.split('T')[0];
				let expDate = tempDateObj.split('-').reverse();
				data.expiryDate = expDate.join('/');
				data.manufacturingDate = data.commonDateVal || data.expiryDate;//for bug #257123
			}
			data.expiryBy = 'manufacturingDate';
			if (consignmentCommand.bestBefore) {
				data.bestBefore = payload.productCommand.consignmentCommand.bestBefore.split("-")[0];
			} else if (consignmentCommand.expiryDate) {
				data.expiryBy = 'expiryDate';
			}

			if (payload.isEdit) {
				data.isEdit = payload.isEdit;
				let prodTypeBreadcrumb = payload.selectedCategory;
				let lastSeperator = prodTypeBreadcrumb.lastIndexOf('>');
				data.itemType = isTemplate ? prodTypeBreadcrumb : prodTypeBreadcrumb.substring(lastSeperator + 1);
				data.productGroup = payload.productCommand.selectedProductGroupIds ? payload.productCommand.selectedProductGroupIds.toString() : '';
				data.category = payload.productCommand.category || payload.productCommand.keywordId;
				data.leafId = payload.productCommand.leafId || null;
				data.productId = payload.productCommand.productId;
				data.unitOfMeasurement = payload.productCommand.unitOfMeasurement;
				data.contentPerPiece = payload.productCommand.contentPerPiece;
				data.unitPerPiece = payload.productCommand.unitPerPiece;
				data.hsnSacNo = payload.productCommand.hsnSacNo;
				data.detailedDescription = payload.productCommand.detailedDescription;
				data.newQuantity = consignmentCommand.quantityLeft || consignmentCommand.quantity;
				data.newQuantity = Number(data.newQuantity) > 0 ? data.newQuantity : "0";
				data.newcostPrice = consignmentCommand.costPrice;
				data.newconsignmentNo = consignmentCommand.cosignment_no;
				data.newsku = consignmentCommand.sku;
				data.actualProductWeight = payload.productCommand.actualProductWeight;
				data.productLength = payload.productCommand.productLength;
				data.productWidth = payload.productCommand.productWidth;
				data.productHeight = payload.productCommand.productHeight;
				data.enquiryPrice = payload.productCommand.enquiryPrice;
				data.minOrderQuantity = payload.productCommand.minOrderQuantity;
				data.maxSupplyCapacity = payload.productCommand.maxSupplyCapacity;
				data.supplyTimePeriod = payload.productCommand.supplyTimePeriod;
				data.enquiryFormId = payload.productCommand.enquiryFormId;
				data.minPrice = payload.productCommand.minPrice;
				data.maxPrice = payload.productCommand.maxPrice;
				data.bulkPricingDetail = payload.productCommand.bulkPricingDetail;
				data.salesTax = payload.productCommand.salesTax || [];
				data.purchaseTax = payload.productCommand.purchaseTax || [];
				data.selectedOutlet = consignmentCommand.accountMongoId ? payload.productCommand.consignmentCommand.accountMongoId.split("-")[0] : "";

				//Reorder Supplier Details
				data.isAutoReorderLevel = payload.productCommand.isAutoReorderLevel;
				data.isAutoReorderQuantity = payload.productCommand.isAutoReorderQuantity;
				data.reorderLevel = payload.productCommand.reorderLevel;
				data.reorderQuantity = payload.productCommand.reorderQuantity;
				data.brandName = payload.productCommand.brandName;
				data.manufacturerName = payload.productCommand.manufacturerName;
				data.associatedSuppliers = payload.productCommand.associatedSuppliers;
				data.associatedSuppliersDetails = payload.productCommand.associatedSuppliersDetails;

				displayData.unitOfMeasurement = payload.productCommand.unitOfMeasurement;
				displayData.unitPerPiece = payload.productCommand.unitPerPiece;

				if (isTemplate) {
					data.templateId = payload.productCommand.templateId;
				}
			}
			consignmentData = payload.productCommand.consignmentCommand;
			const newState = { ...state };
			newState.productPuvMap = payload.productCommand.productPuvMap;
			newState.itemInfo = {
				...newState.itemInfo,
				...data
			}
			newState.consignmentData = {
				...newState.consignmentData,
				...consignmentData
			}
			newState.displayInfo = {
				...newState.displayInfo,
				...displayData
			}
			newState.isTemplate = isTemplate;
			return newState;
		}
		case RESET_ITEM_INFO: {
			return {
				...initialState, ...initialState.itemInfo.imageUrlArr = [], ...initialState.itemInfo.associatedSuppliersDetails = [],
				newCategoryImage: []
			}
		}
		case IMAGE_UPLOAD_STATUS: {
			const newState = {...state};
			newState.imagesUploadStatus = payload;
			newState.newCategoryImage = [];
			return newState;
		}
		default:
			return state;
	}
};